import { DealType } from '@repo/database/src/types';
import { Transform } from 'class-transformer';
import { IsBoolean, IsDate, IsEnum, IsNumber, IsOptional, IsUUID, Max, Min, ValidateIf } from 'class-validator';

export class UpdateAgentDealDto {
  @IsOptional()
  @IsEnum(DealType, { message: 'Please select a valid deal type' })
  dealType?: DealType;

  @IsOptional()
  @IsNumber({}, { message: 'Please enter a valid rake share percentage' })
  @Min(5, { message: 'Rake share percentage must be at least 5%' })
  @Max(45, { message: 'Rake share percentage cannot exceed 45%' })
  rakeSharePercentage?: number;

  @IsOptional()
  @ValidateIf((o) => o.dealType === DealType.FLAT)
  @IsNumber({}, { message: 'Please enter a valid flat fee amount' })
  @Min(0, { message: 'Flat fee must be a positive amount' })
  flatFee?: number | null;

  @IsOptional()
  @IsNumber({}, { message: 'Please enter a valid bonus amount' })
  @Min(0, { message: 'Bonus must be a positive amount' })
  bonus?: number | null;

  @IsOptional()
  @IsDate({ message: 'Please select a valid start date' })
  @Transform(({ value }) => (value ? new Date(value) : undefined))
  startDate?: Date;

  @IsOptional()
  @IsDate({ message: 'Please select a valid end date' })
  @Transform(({ value }) => (value ? new Date(value) : undefined))
  endDate?: Date;

  @IsOptional()
  @IsBoolean({ message: 'Regional manager flag must be a boolean' })
  isRegionalManager?: boolean;

  @IsOptional()
  @ValidateIf((o) => o.isRegionalManager === true)
  @IsUUID(4, { message: 'Invalid region selected' })
  regionId?: string | null;

  @IsOptional()
  @IsBoolean({ message: 'Automatic downline inheritance flag must be a boolean' })
  automaticDownlineInheritance?: boolean;

  @IsOptional()
  @IsBoolean({ message: 'Complete user visibility flag must be a boolean' })
  completeUserVisibility?: boolean;

  /**
   * Controls whether the agent can create sub-agents.
   */
  @IsOptional()
  @IsBoolean({ message: 'canCreateSubAgents must be a boolean value' })
  canCreateSubAgents?: boolean;
}
